// serverlessSearchService — the app's search API surface, backed by the
// serverless/hybrid (AOSS) stack via the /searchServerless/* routes.
import { apiUrl } from "./apiClient";
import httpOption from "../services/httpOption";

async function searchFetch(path, { signal, failurePrefix, logMessage }) {
  const options = httpOption.GET();
  options.headers = {
    ...options.headers,
    "Content-Type": "application/json",
  };
  if (signal) {
    options.signal = signal;
  }

  try {
    const response = await fetch(apiUrl(path), options);
    if (!response.ok) {
      throw new Error(
        `${failurePrefix}: ${response.status} ${response.statusText}`,
      );
    }
    return await response.json();
  } catch (error) {
    console.error(logMessage, error);
    throw error;
  }
}

export function getArticleByQueryPaginated(
  query,
  from = 0,
  size = 10,
  filter = "All",
  pageSize = 5,
) {
  const params = new URLSearchParams({
    q: query,
    from: String(from),
    size: String(size),
    filter,
    paginated: "true",
    pageSize: String(pageSize),
  });

  return searchFetch(`/searchServerless/search?${params.toString()}`, {
    failurePrefix: "Search failed",
    logMessage: "Error fetching paginated articles from serverless search:",
  });
}

// Title-only search — searches only the title field for related content.
export function searchByTitleOnly(query, from = 0, size = 10) {
  const params = new URLSearchParams({
    q: query,
    from: String(from),
    size: String(size),
    searchMode: "title",
  });

  return searchFetch(`/searchServerless/search?${params.toString()}`, {
    failurePrefix: "Title search failed",
    logMessage: "Error in title-only search (serverless):",
  });
}

export async function getAutocompleteSuggestions(query, size = 5, signal) {
  return searchFetch(
    `/searchServerless/autocomplete?q=${encodeURIComponent(query)}&size=${size}`,
    {
      signal,
      failurePrefix: "Error fetching autocomplete suggestions",
      logMessage:
        "Error fetching autocomplete suggestions from serverless search:",
    },
  );
}
